<script setup lang="ts">
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG } from '@/utils';
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose, defineProps, reactive, onMounted, toRaw } from 'vue';

    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const formData = reactive({
        id: null,
        nom: '',
        montant: 0,
        quantite: 0,
        image: null as any,
        image_preview: '/assets/users/default.png',
    });
    const errors = reactive({
        montant: "",
        quantite: "",
    });
    const produit = reactive({
        id: null,
        nom: '',
        montant: 0,
        quantite: 0,
    });

    async function open(_produit: any, _variant: any) {
        Object.assign(produit, _produit);
        Object.assign(formData, _variant);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onConfirm() {
        resolvePromise({
            id: formData.id,
            nom: formData.nom,
            montant: formData.montant,
            quantite: formData.quantite,
            images: formData.image ? [formData.image] : [],
            images_previews: formData.image_preview ? [formData.image_preview] : [],
        });
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(false);
        isModalOpen.value = false;
    }

    function onFileImageUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.image_preview = uploadedFile.file_preview;
        formData.image = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" classesNames="modal-lg" @closed="onClose">
        <template #header>
            <h4 class="font-semibold">Formulaire Variant</h4>
        </template>
        <div>
            <section class="s15_mobile px-4">
                <div class="widget px-7 py-7">
                    <h4 class="font-semibold mb-5">Variant produit / Edition <span class="text-sm text-grey-500"></span></h4>

                    <div class="form-field-floating reactive active my-4">
                        <input type="text" class="form-input" v-model="produit.nom" name="nom_produit" id="nom_produit" placeholder="" autocomplete="off" :readonly="true">
                        <label for="nom_produit">Article <b class="color-danger">*</b></label>
                    </div>

                    <div class="form-field-floating reactive active my-4">
                        <input type="text" class="form-input" v-model="formData.nom" name="nom" id="nom" placeholder="" autocomplete="off" :readonly="true">
                        <label for="nom">Variant <b class="color-danger">*</b></label>
                    </div>
                    
                    <div class="form-field-floating reactive active my-4">
                        <money3 class="form-input" v-model="formData.montant" name="montant" id="montant" placeholder="" v-bind="AMOUNT_FORMAT_CONFIG"></money3>
                        <label for="montant">Prix unitaire <b class="color-danger">*</b></label>
                    </div>
                    <span v-if="!!errors['montant']" class="text-red">{{ errors['montant'] }}</span>

                    <div class="form-field-floating reactive active my-4">
                        <money3 class="form-input" v-model="formData.quantite" name="quantite" id="quantite" placeholder="" v-bind="INTEGER_FORMAT_CONFIG"></money3>
                        <label for="quantite">Stock initial</label>
                    </div>
                </div>
            </section>
            <section class="s5_mobile px-4">
                <div class="widget px-7 py-7">
                    <h4 class="font-semibold mb-5 text-center">Image <span class="text-sm text-grey-500"></span></h4>
                    <div class="custom-upload-size margin-auto flex mb-8">
                        <custom-upload-input id="image-variant" label="Image" type="IMAGE" :preview="formData.image_preview" @uploaded="onFileImageUploaded"></custom-upload-input>
                    </div>
                </div>
            </section>
            <div class="clear-both"></div>
        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onConfirm">Valider</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Annuler</button>
        </template>
    </custom-modal>
</template>
